import React, {useEffect, useState} from "react";
import App from "../../routes/index";
import {useRouteMatch, useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Badge, Layout, Dropdown, Menu, Button} from "antd";
import {footerText} from "../../util/config";
import Sidebar from "../Sidebar";
import SidebarContent from "../Sidebar/SidebarContent";
import {BellFilled, CaretDownFilled, PoweroffOutlined, SettingOutlined} from "@ant-design/icons";
import {DOCUMENT_BASE_URL} from "../../constants/ServerUrl";
import {NoPageAccess} from "../../components/NoPageAccess";
import AlertNotification from "../Alert";
import {userSignOut} from "../../appRedux/actions";

const alert = "😊 Hey Champ!, Great work so far. Just a friendly reminder to checkout before leaving. Cheers! 👍"

const {Content, Sider, Header, Footer} = Layout;
const MainApp = () => {
    let [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    const match = useRouteMatch();
    const history = useHistory();

    const {authUser} = useSelector(({auth}) => auth);
    const dispatch = useDispatch();

    const menu = (
        <Menu>
          <Menu.Item>
            <p onClick={() => dispatch(userSignOut())} className="flex items-center text-gray-700 hover:text-gray-900">
                <PoweroffOutlined className="mr-2" />
                Sign Out
            </p>
          </Menu.Item>
          <Menu.Item>
            <p onClick={() => history.push('/account-settings')} className="flex items-center text-gray-700 hover:text-gray-900">
                <SettingOutlined className="mr-2" />
                Account Settings
            </p>
          </Menu.Item>
        </Menu>
      );


    return (
        <Layout className="">

            <Sidebar sidebarCollapsed={sidebarCollapsed}/>
            <Layout>
                <AlertNotification message={alert}  hour="18" minute="44"> </AlertNotification>
                <Header className="bg-white p-0 h-20">

                    {authUser && (
                        <div className="flex justify-end space-x-10 mt-2 mr-5 md:mr-20 xl:mr-24">
                            <div className="hidden">
                                <Badge dot>
                                    <BellFilled/>
                                </Badge>
                            </div>

                            {authUser.profile_photo_path && (
                                    <div className="flex cursor-pointer">
                                        <div className="rounded-full p-1 flex-none">
                                            <img width="50" className="rounded-full" alt={authUser.first_name}
                                                src={`${DOCUMENT_BASE_URL}/${authUser.profile_photo_path}`}/>
                                        </div>
                                        <Dropdown overlay={menu} trigger={['click']} className="flex-shrink">
                                            {/* <Button className="items-center self-center ml-1"> */}
                                                <p className="font-semibold">
                                                    <CaretDownFilled className="pl-4"/>
                                                </p>
                                            {/* </Button> */}
                                        </Dropdown>
                                    </div>
                            )}
                            {!authUser.profile_photo_path && (
                                    <div className="flex cursor-pointer">
                                            <div className="rounded-full p-1 flex-none">
                                                <img width="50" className="rounded-full" alt="POSNL"
                                                    src="/images/app-icons/placeholder.jpg"/>
                                            </div>
                                            <Dropdown overlay={menu} trigger={['click']} className="flex-shrink">
                                                {/* <Button className="items-center self-center ml-1"> */}
                                                    <p className="font-semibold">
                                                        <CaretDownFilled className="pl-4"/>
                                                    </p>
                                                {/* </Button> */}
                                            </Dropdown>
                                    </div>
                            )}
                        </div>)}
                    {!authUser && (
                        <div className="flex justify-center md:justify-end space-x-10 mt-2 md:mr-20 xl:mr-24">
                            <div className="hidden">

                                <Badge dot>
                                    <BellFilled/>
                                </Badge>
                            </div>
                            <div className="flex cursor-pointer">
                                <div className="rounded-full p-1">

                                    <img width="50" className="rounded-full" alt="Phillips Outsourcing"
                                         src="/images/app-icons/placeholder.jpg"/>
                                </div>
                                <div>

                                    <p className="flex pl-3 font-semibold">Welcome<CaretDownFilled
                                        className="pl-4"/></p>
                                </div>
                            </div>


                        </div>

                    )}
                </Header>
                <Content className="overflow-auto h-screen">
                    {authUser && (
                        <>
                            {(authUser.employee_status_id.toString() !== "1") ? (
                                <NoPageAccess/>
                            ) : (<App match={match}/>)}
                        </>
                    )}

                    <Footer className="pl-3 md:px-0 md:mx-5 lg:mx-10">
                        <div className="gx-layout-footer-content">
                            {footerText}
                        </div>
                    </Footer>
                </Content>

            </Layout>
        </Layout>
    )
};
export default MainApp;

